import { render } from "./NewWorkspacePage.vue?vue&type=template&id=3b6f9158&scoped=true&ts=true"
import script from "./NewWorkspacePage.vue?vue&type=script&lang=ts"
export * from "./NewWorkspacePage.vue?vue&type=script&lang=ts"

import "./NewWorkspacePage.vue?vue&type=style&index=0&id=3b6f9158&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6f9158"]])

export default __exports__